// Application-wide constants

export const SCRIPTURE_COPYRIGHT_TEXT =
    "The Holy Bible, New International Version® NIV®. Copyright © 1973, 1978, 1984, 2011 by Biblica, Inc.® Used by Permission of Biblica, Inc.® All rights reserved worldwide.";
